import { render, staticRenderFns } from "./key-value-unit.vue?vue&type=template&id=27837a51&scoped=true"
import script from "./key-value-unit.vue?vue&type=script&lang=js"
export * from "./key-value-unit.vue?vue&type=script&lang=js"
import style0 from "./key-value-unit.vue?vue&type=style&index=0&id=27837a51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27837a51",
  null
  
)

export default component.exports